import { render, staticRenderFns } from "./DepositLimitHistories.vue?vue&type=template&id=3687e358&"
import script from "./DepositLimitHistories.vue?vue&type=script&lang=js&"
export * from "./DepositLimitHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports